import { Grid, Paper, Typography } from "@mui/material";
import React from "react";
import { styles } from "../../../theme/styles";
import { InputButton } from "../../../components";
import { colors } from "../../../theme";
// import hero from "../../../medias/hero7.jpg";

// Interface
interface CardProps {
  title: string;
  subTitle: string;
  description: string;
  button: React.ReactNode;
  type: "main" | "disabled" | "primary" | "secondary";
  list?: string[];
  style?: React.CSSProperties;
  pathName?: string;
  width?: string;
  height?: string;
}

export const PlanCard = ({
  title,
  subTitle,
  description,
  button,
  type,
  list,
  style,
  pathName,
  width,
  height,
}: CardProps) => {
  // let heroImage;

  // Verifica se pathName foi fornecido e tenta importar dinamicamente a imagem
  if (pathName)
    try {
      // heroImage = require(`../../../medias/${pathName}`);
    } catch (error) {
      console.error("Erro ao carregar a imagem:", error);
    }
  // else heroImage = hero;

  return (
    <Grid item md={4} xs={12} style={{ padding: 0 }}>
      <Paper
        style={{
          ...styles.card,
          ...style,
        }}
      >
        {/* <img
            src={heroImage}
            style={{
              borderRadius: "50%",
              width,
              height,
              // height: "20%",
              marginBottom: "1%",
              marginTop: "0%"
            }}
            alt="Imagem"
          /> */}
        <Typography variant="h4">{title}</Typography>
        <Typography variant="h6">{subTitle}</Typography>
        <Typography
          variant="body2"
          style={{
            paddingLeft: "4%",
            margin: "2%",
            color: colors.font.primary,
            fontSize: "14px",
            height: "55px",
            marginTop: "10px",
            // backgroundColor: "white",
          }}
        >
          {description}
        </Typography>
        <InputButton
          type={type}
          style={{
            marginTop: "1.55%",
            // minWidth: undefined,
            width: "70%",
            // height: "100%",
            // padding: 0,
          }}
          // disabled=true
          // onClick={() => handleSendInteractionToCycle("A")}
          tooltip="Plan Card"
        >
          {button}
        </InputButton>
        {/* <Button style={{ ...styles.cardButton }}>{button}</Button> */}
        <div
          style={{
            marginTop: "10px",
            // position: "relative",
            width: "100%",
            // display: "flex", justifyContent: "center", alignItems: "center"
            // display: "flex",
            // alignItems:"center",
          }}
        >
          <ul
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              margin: "2%",
              // width: "100%",
              height: "100%",
            }}
          >
            {list &&
              list.map((item, index) => (
                //  <li key={index}>{item} </li>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    // alignItems: "center",
                    margin: "2%",
                    // position:"relative",
                    width: "100%",
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    // class="lucide-icon lucide lucide-check-circle-2 h-6 min-h-6 w-6 min-w-6"
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                    <path d="m9 12 2 2 4-4"></path>
                  </svg>
                  <span
                    style={{
                      paddingLeft: "2%",
                      // paddingRight: "2%",
                      // width: "100%"
                      // display: "block",
                      // width: "100%",
                      // height: "100%",
                    }}
                  >
                    {item}
                  </span>
                </div>
              ))}
          </ul>
        </div>
      </Paper>
    </Grid>
  );
};
